<div class="messages-section box_default box_white">
  <header>
    <h3>MESSAGES</h3>
  </header>
  <div class="loader">
    <div class="dimmed" [hidden]="versionMessages != null && access != null">
      <div class="dimmed_avatar"></div>
      <div class="dimmed_info">
        <div class="dimmed_title"></div>
        <div class="dimmed_subtitle"></div>
      </div>
    </div>
  </div>

  <article *ngIf="versionMessages != null && access != null" class="messages-section-main">
   
    <!-- add form checking access-->
    <div class="version-messages-form" *ngIf="access.access_version_write_comments">
      <core-message-add
            [action]="messageAddUrl"
            (onSaved)="onUpdateMessages($event)">
        </core-message-add>
    </div>
    <!-- list -->
    <div class="version-details-comments-list">
      <article *ngIf="versionMessages!=null && versionMessages.length==0" class="message-not-content">
        <core-helpers-box-alert-message-icon
          [text]="'There are currently no messages.'"
          [icon]="'no_messages'"
        ></core-helpers-box-alert-message-icon>
      </article>
      <ul class="comments-list" *ngIf="versionMessages.length > 0">
        <li class="comments-timeline-item" *ngFor="let vmessage of versionMessages | sortBy: 'date' : 'desc'; let i = index; trackBy: trackByMessageId">
          <core-message
              *ngIf="vmessage.message"
              [message]="vmessage.message"
              [canCreateNotes]="access.access_version_write_comments"
              [delete]="vmessage.message.user.id == user.id"
              (onDelete)="onDeleteMessage($event)"
              [prefixUrl]="prefixUrl"
          ></core-message>
            
          <!-- Display file attachments directly with core-signed-files-list -->
          <div class="message-attachments" *ngIf="vmessage.message?.attachments?.length > 0">
              <header>
                <h4 *ngIf="isAttachmentsOpen(vmessage.message, i)" (click)="toggleAttachments(vmessage.message, i)"><em>{{vmessage.message?.attachments?.length}}</em> <span
                    class="arrow-up">Attachment{{vmessage.message?.attachments?.length > 1 ? 's':''}}</span></h4>
                <h4 *ngIf="!isAttachmentsOpen(vmessage.message, i)" (click)="toggleAttachments(vmessage.message, i)"><em>{{vmessage.message?.attachments?.length}}</em> <span
                    class="arrow-down">Attachment{{vmessage.message?.attachments?.length > 1 ? 's':''}}</span></h4>
            </header>
            <div [hidden]="!isAttachmentsOpen(vmessage.message, i)"  class="message-attachments-content messages">
              <core-signed-files-list 
                  *ngIf="vmessage.message?.attachments?.length > 0"
                  [files]="vmessage.message.attachments"
                  [notes]="getNotesForMessage(vmessage.message)"
                  [annotationsUrl]="'/messages/'+vmessage.message.id"
                  [canCreateNotes]="access.access_version_write_comments"
                  [annotationsUser]="user"
                  [menu]="fileMenu"
                  [scope]="'message-default'"
                  (refreshSignaturesNeeded)="onRefreshSignaturesNeeded()"
                  (menuClick)="onFileMenuClick($event)"
                  (iconDownloadClick)="onFileIconDownloadClick($event)"
                  (annotationsSaved)="onNotesSaved(vmessage.message, $event)"
              ></core-signed-files-list>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </article>
</div>
